import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faUnity} from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "Vue",
    "TypeScript",
    "JavaScript",
    "HTML5",
    "CSS3",
    ".Net",
    "SASS",
    "Python",
    "SQL",
    "PostgreSQL",
    "Postman"
];

const labelsSecond = [
    "Git",
    "GitHub Actions",
    "Docker",
    "AWS",
    "Azure",
    "Digital Ocean",
    "Linux",
    "Selenium"
];

const labelsThird = [
    "Unity",
    "C#",
    "Photon",
    "Node.js",
    "MongoDB",
    "Solidity",
    "Unreal Engine 4"

];

function Expertise() {
  const {t} = useTranslation();
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>{t('expertise')}</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>{t('fullStack')}</h3>
                    <p>{t('fullStackDescription')}</p>
                    <div className="flex-chips">
                        <span className="chip-title">{t('techStack')}</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>{t('devOps')}</h3>
                    <p>{t('devOpsDescription')}</p>
                    <div className="flex-chips">
                        <span className="chip-title">{t('techStack')}</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faUnity} size="3x"/>
                    <h3>{t('gameDev')}</h3>
                    <p>{t('gameDevDescription')}</p>
                    <div className="flex-chips">
                        <span className="chip-title">{t('techStack')}</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;